import React, { useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import "./style.css";
import { publishImage } from "../../../helpers/imageupload";
import { SuccessNotify, FailedNotify } from "../../../constants/tostify";
import { useVerifyDocsMutation } from "../../../features/marketing/marketingApiSlice";

const ActiveModal = ({ show, onHide }) => {
  // ================= REDUX =================
  const { name } = useSelector((state) => state.user);
  const userId = name?._id;

  // ================= RTK QUERY =================
  const [verifyDocs] = useVerifyDocsMutation();

  // ================= FILE STATE =================
  const [files, setFiles] = useState({
    idCardFront: null,
    idCardBack: null,
    cnicFront: null,
    cnicBack: null,
    qualification: null,
  });

  const [uploading, setUploading] = useState(false);

  // ================= FILE CHANGE =================
  const handleFileChange = (e) => {
    const { name, files } = e.target;
    setFiles((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

  // ================= SUBMIT =================
  const handleSubmit = async () => {
    if (
      !files.idCardFront ||
      !files.idCardBack ||
      !files.cnicFront ||
      !files.cnicBack ||
      !files.qualification
    ) {
      FailedNotify("Please upload all required documents");
      return;
    }

    try {
      setUploading(true);

      // 1️⃣ Upload images
      const uploadedUrls = await publishImage(
        [
          files.idCardFront,
          files.idCardBack,
          files.cnicFront,
          files.cnicBack,
          files.qualification,
        ],
        (percent) => console.log("Upload Progress:", percent + "%"),
      );

      // 2️⃣ Prepare body (matches backend UpdateDocsVerify fields exactly)
      const body = {
        idCardFront: uploadedUrls[0], // ID Card Front  → IDFront
        idCardBack: uploadedUrls[1], // ID Card Back   → IDBack
        fatherIdFront: uploadedUrls[2], // cnicFront      → fatherIdFront
        fatherIdBack: uploadedUrls[3], // cnicBack       → fatherIdBack
        lastDegree: uploadedUrls[4], // qualification  → lastDegree
      };

      // 3️⃣ RTK Query mutation — inherits auth token automatically, no 401 auto-logout risk
      const res = await verifyDocs({ userId, body }).unwrap();

      // Optional
      onHide();
      SuccessNotify(
        "Documents submitted! Your account is pending for review. This may take up to 24 hours.",
      );
    } catch (error) {
      console.error("Verification failed", error);
      FailedNotify(
        error?.data?.message || "Document submission failed. Please try again.",
      );
    } finally {
      setUploading(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="verification-modal"
    >
      <Modal.Header className="verification-header d-flex justify-content-end">
        <div className="close-btn" onClick={onHide}>
          <b>✕</b>
        </div>
      </Modal.Header>

      <Modal.Body className="verification-body">
        <h4>
          Provide Required Documents Mention Below To Activate Your Account
        </h4>

        {/* Upload ID Card */}
        <div className="section-active-modal mt-4">
          <h6>Upload ID Card</h6>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  ID Card <span>(Front)</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="idCardFront"
                  className="file-input"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  ID Card <span>(Back)</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="idCardBack"
                  className="file-input"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>

        {/* Father / Mother CNIC */}
        <div className="section-active-modal">
          <h6>Father / Mother / Guardian CNIC</h6>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  CNIC <span>(Front)</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="cnicFront"
                  className="file-input"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  CNIC <span>(Back)</span>
                </Form.Label>
                <Form.Control
                  type="file"
                  name="cnicBack"
                  className="file-input"
                  onChange={handleFileChange}
                />
              </Form.Group>
            </Col>
          </Row>
        </div>

        {/* Qualification */}
        <div className="section-active-modal">
          <h6>Higher Qualification</h6>
          <Form.Group className="mb-4">
            <Form.Label>Upload Document</Form.Label>
            <Form.Control
              type="file"
              name="qualification"
              className="file-input"
              onChange={handleFileChange}
            />
          </Form.Group>
        </div>

        {/* Submit */}
        <div className="d-flex justify-content-end">
          <Button onClick={handleSubmit} disabled={uploading}>
            {uploading ? "Submitting..." : "Submit"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ActiveModal;
